export const size = {
  mobileS: "320px",
  mobileM: "398px",
  mobileL: "526px",
  mobileLL: "665px",
  tablet: "768px",
  laptop: "1024px",
  laptopL: "1920px",
  desktop: "2560px",
};
export const device = {
  mobileS: `(max-width: ${size.mobileS})`,
  mobileM: `(max-width: ${size.mobileM})`,
  mobileL: `(max-width: ${size.mobileL})`,
  mobileLL: `(max-width: ${size.mobileLL})`,
  tablet: `(max-width: ${size.tablet})`,
  laptop: `(max-width: ${size.laptop})`,
  laptopL: `(max-width: ${size.laptopL})`,
  desktop: `(max-width: ${size.desktop})`,
  desktopL: `(max-width: ${size.desktop})`,
};
